export default {"src":"/_next/static/media/quotes.c884296b.svg","height":217,"width":315,"blurWidth":0,"blurHeight":0};